import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "./calendar.css";

const NewsCalendar = () => {
  const events = [
    {
      title: "สรุปรายงานงบประมาณประจำปี 2566",
      start: "2024-10-08T13:00:00",
      end: "2024-10-08T15:30:00",
    },
    {
      title: "ประชุมสัมมนาวิชาการการป้องกันภัยคุกคามทางไซเบอร์",
      start: "2024-10-09T08:00:00",
      end: "2024-10-09T10:00:00",
    },
  ];

  return (
    <div className="p-4 max-w-6xl mx-auto bg-white rounded-lg shadow">
      <h1 className="text-xl font-semibold mb-4">ปฏิทินกิจกรรม</h1>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        locale="th"
        headerToolbar={{
          start: "today prev,next",
          center: "title",
          end: "dayGridMonth,timeGridWeek",
        }}
        events={events}
        height="auto"
      />
    </div>
  );
};

export default NewsCalendar;
